import { FormControl, FormGroup } from '@angular/forms';
import { Options } from '../../../shared/report-format/report-format.constants';

export const DRIVER_LOAD_REPORT_LABELS = {
  HEADER: $localize`Driver Load Report`,
  DATE: $localize`Date`,
  ROUTE: $localize`Route`,
};
export const REPORT_FILE_NAME = 'Driver-Load-Report';

type DriverLoadFormField = {
  date: FormControl<Date>;
  route: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type DriverLoadFormGroup = FormGroup<DriverLoadFormField> | null;
